export default class Trip {
    id: number;
    carName?: string;
    carRegisterNumber?: string;
    startDateTime: string;
    endDateTime: string;
    startPlace: string;
    startPlaceId: number;
    endPlace: string;
    endPlaceId: number;
    passengerId: number;
    movitPassengerId: string;
    cancelledAt?: string;
    cancelledBy?: string;
    cancelReason?: string;
    pickupTime?: string;
    dropoffTime?: string;
    noShowTime?: string;
    selectedForCancelling: boolean;
    
    constructor(options) {
        this.id = options && options.id ? options.id : null;
        this.passengerId = options && options.passengerId ? options.passengerId : null;
        this.carName = options && options.carName ? options.carName : null;
        this.carRegisterNumber = options && options.carRegisterNumber ? options.carRegisterNumber : null;
        this.startDateTime = options && options.startDateTime ? options.startDateTime : null;
        this.endDateTime = options && options.endDateTime ? options.endDateTime : null;
        this.startPlace = options && options.startPlace ? options.startPlace : null;
        this.endPlace = options && options.endPlace ? options.endPlace : null;
        this.movitPassengerId = options && options.movitPassengerId ? options.movitPassengerId : null;
        this.cancelledAt = options && options.cancelledAt ? options.cancelledAt : null;
        this.cancelledBy = options && options.cancelledBy ? options.cancelledBy : null;
        this.cancelReason = options && options.cancelReason ? options.cancelReason : null;
        this.pickupTime = options && options.pickupTime ? options.pickupTime : null;
        this.dropoffTime = options && options.dropoffTime ? options.dropoffTime : null;
        this.noShowTime = options && options.noShowTime ? options.noShowTime : null;
        this.selectedForCancelling = false;
    }

    public static WithPassengerId(tripFromApi, passengerId: number) {
        const trip = new Trip(tripFromApi);
        trip.passengerId = passengerId;
        return trip;
    }

    get date() {
        const test =  (this.startDateTime || this.endDateTime).split('T');
        return test[0]
    }
  }
